<template>
  <div>
    <v-btn color="primary" class="ml-4" @click="dialog_ativo = true">
      <v-icon left>mdi-plus</v-icon>
      Novo
    </v-btn>

    <v-dialog v-model="dialog_ativo" fullscreen persistent>
      <v-card>
        <v-card-title class="pa-0">
          <div class="w-full d-flex align-center py-3 px-2" style="background: #042333">

            <v-btn icon dark @click="fecharDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <span class="text-white ml-3">Cadastro de produto acabado</span>

            <v-spacer />

            <v-btn color="primary" @click="salvarCadastro">Salvar</v-btn>
          </div>
        </v-card-title>

        <v-card-text v-if="dialog_ativo" class="pa-0">
          <div class="d-flex">
            <v-col cols="5">
              <v-text-field
                v-if="item_para_edicao.idproduto"
                :value="`${item_para_edicao.idproduto} - ${item_para_edicao.descricao_produto}`"
                label="Selecione o produto acabado"
                disabled
                outlined
              />

              <SysProdutoAutocomplete
                v-else
                v-model="cadastro.produto_acabado"
                label="Selecione o produto acabado"
                outlined
                height="10"
                return-object
                clearable
                :messages="MENSAGENS_PRODUTO_ACABADO"
                :error-messages="mensagensDeErros('produto_acabado')"
              />
            </v-col>

            <v-col cols="7" class="pb-0 px-2 border-left h-coluna">
              <SysProdutoAutocomplete
                v-model="cadastro.materia_prima"
                :label="!cadastro.materia_prima.length ? 'Selecione as matérias primas' : ''"
                hide-no-data
                hide-selected
                outlined
                multiple
                return-object
                clearable
                :error-messages="mensagensDeErros('materia_prima')"
              >
                <template #selection>
                  <!-- NADA -->
                </template>

                <template #prepend-inner>
                  <v-chip v-if="cadastro.materia_prima.length > 0" class="mt-n1 txt-row" v-text="QTDE_MATERIA_PRIMA_SELECIONADA" />
                </template>
              </SysProdutoAutocomplete>

              <div v-if="cadastro.materia_prima.length > 0" class="mt-n5">
                <div>
                  <v-icon size="13">mdi-format-list-bulleted</v-icon>
                  <span class="ml-1 font-12">Lista de matérias primas selecionadas</span>
                </div>

                <div class="h-tabela overflow-y-auto">
                  <table class="w-full text-left font-12 border-top-itens-tabela border-collapse">
                    <thead>
                      <tr>
                        <th class="font-weight-medium">Matéria prima</th>
                        <th class="font-weight-medium text-center w-max-150">
                          <span class="ml-n5">Fator</span>
                        </th>
                        <th class="font-weight-medium pl-3">Fora de linha</th>
                        <th class="font-weight-medium pr-3">Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      <template v-for="(_, index) in cadastro.materia_prima">
                        <MateriaPrimaSelecionado
                          v-model="cadastro.materia_prima[index]"
                          :key="index"
                          @remover-item="removerMateriaPrima"
                        />
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete";
import MateriaPrimaSelecionado from "@/components/fichaTecnicaProducao/ProdutoAcabado/MateriaPrimaSelecionado";
import {salvarFichaTecnicaProdutoAcabado} from '@/api/fichaTecnicaProducao';
import {logout} from "@/helpers";
import {required} from "vuelidate/lib/validators";

export default {
  name: "Cadastro",
  components: {
    MateriaPrimaSelecionado,
    SysProdutoAutocomplete
  },
  props: {
    item_para_edicao: Object
  },
  data: () => ({
    dialog_ativo: false,
    cadastro: {
      produto_acabado: {},
      materia_prima: []
    }
  }),
  validations: {
    cadastro: {
      produto_acabado: { required },
      materia_prima: { required },
    },
  },
  computed: {
    QTDE_MATERIA_PRIMA_SELECIONADA() {
      if (!this.cadastro.materia_prima || !this.cadastro.materia_prima.length) {
        return 'Nenhuma matéria prima selecionada';
      }

      const plural = this.cadastro.materia_prima.length > 1 ? 's' : '';
      return `${this.cadastro.materia_prima.length} Matéria prima${plural} selecionada${plural}`;
    },
    MENSAGENS_PRODUTO_ACABADO() {
      const {produto_acabado} = this.cadastro;

      if (! produto_acabado.id_produto) {
        return '';
      }

      let txt = '';

      if (produto_acabado.fora_linha) {
        txt += 'Produto fora de linha';
      }
      if (!produto_acabado.ativo_venda) {
        txt += (txt.length > 0) ? ' e inativo para revenda' : 'Produto inativo para revenda';
      }

      return txt;
    }
  },
  watch: {
    item_para_edicao() {
      if (!this.item_para_edicao.idproduto) {
        this.resetarCadastro();
      } else {
        this.abrirDialogParaEdicao();
      }
    }
  },
  methods: {
    mensagensDeErros(campo) {
      const errors = [];
      if (!this.$v.cadastro[campo].$dirty) return errors;
      !this.$v.cadastro[campo].required && errors.push("Campo Obrigatório.");
      return errors;
    },
    resetarCadastro() {
      this.cadastro = {
        produto_acabado: {},
        materia_prima: []
      };
    },
    abrirDialogParaEdicao() {
      const callback = item => {
        return {
          id_produto: item.idproduto,
          descricao: item.descricao_produto,
          peso_pa: Number(item.peso_pa),
          fora_linha: item.fora_linha,
          idunidade_medida: item.idunidade_medida,
          utilizado_por_categoria: item.utilizado_por_categoria
        };
      };

      const {idproduto: id_produto, materias_primas} = this.item_para_edicao;

      this.cadastro = {
        produto_acabado: {id_produto},
        materia_prima: materias_primas.map(callback),
        edicao: true
      };

      this.dialog_ativo = true;
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.$emit('resetar-item-edicao', {});
    },
    removerMateriaPrima(materia_prima) {
      const callback = item => item !== materia_prima;
      this.cadastro.materia_prima = this.cadastro.materia_prima.filter(callback);
    },
    salvarCadastro() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const materias_primas = this.Helpers.arrayColumn(this.cadastro.materia_prima, ['id_produto', 'peso_pa']);

      const parametros = {
        produto_acabado: this.cadastro.produto_acabado.id_produto,
        materias_primas
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarFichaTecnicaProdutoAcabado(parametros)
          .then(() => {
            this.$emit('salvo-sucesso', {});
            this.fecharDialog();
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
.h-tabela {
  height: calc(100vh - 165px)
}
.border-collapse {
  border-collapse: collapse;
}
.border-left {
  border-left: 1px solid #e8e8e8;
}
.h-coluna {
  height: calc(100vh - 70px);
}
</style>
